import { KeyInfo } from '@/components/common/form/types'
import { ApiGeneralSinglePayload } from '@/tcw/api/types'

export const Paths: { [category: string]: { [type: string]: string } } = {
  Login: {
    get: '/login',
    delete: '/logout'
  },
  Session: {
    get: '/user/appdata'
  },
  KintaiMonth: {
    get: '/summary/{year}/{month}',
    init: '/kintai/{year}/{month}/init/{patternId}'
  },
  OtherKintaiMonth: {
    get: '/summary/{userId}/{year}/{month}'
  },
  KintaiInput: {
    get: '/kintai/{year}/{month}/{day}/default',
    default: '/kintai/{year}/{month}/{day}',
    post: '/kintai/{year}/{month}/{day}',
    put: '/kintai/{year}/{month}/{day}',
    calc: '/kintai/calc'
  },
  KintaiExists: {
    get: '/kintai/{year}/{month}/{day}'
  },
  KintaiCheck: {
    get: '/kintai/check/{year}/{month}',
    other: '/kintai/check/{year}/{month}/{userId}'
  },
  Chienshomei: {
    get: '/kintai/chienshoumei/{kintaiId}',
    post: '/kintai/chienshoumei/{kintaiId}',
    put: '/kintai/chienshoumei/{kintaiId}',
    delete: '/kintai/chienshoumei/{id}'
  },
  Teishutsu: {
    get: '/teishutsu/{year}/{month}'
  },
  TeishutsuInput: {
    get: '/teishutsu/{year}/{month}',
    empty: '/teishutsu/{year}/{month}',
    post: '/teishutsu/{year}/{month}',
    put: '/teishutsu/{year}/{month}'
  },
  TeishutsuOther: {
    get: '/teishutsu/{year}/{month}/{userId}'
  },
  TeishutsuStatus: {
    get: '/teishutsu/member/status/{year}/{month}'
  },
  TeishutsuRireki: {
    get: '/teishutsu/rireki'
  },
  UserSettei: {
    get: '/settei/user',
    put: '/settei/user'
  },
  SlackSubmit: {
    test: '/develop/slack/test/{slackName}'
  },
  Project: {
    get: '/settei/project',
    post: '/settei/project',
    empty: '/settei/project/empty'
  },
  ProjectCalc: {
    shotei: '/settei/project/calc/shotei'
  },
  KintaiPatternList: {
    get: '/settei/kintai'
  },
  KintaiPatternEdit: {
    get: '/settei/kintai/{id}',
    post: '/settei/kintai',
    put: '/settei/kintai',
    delete: '/settei/kintai/{id}',
    empty: '/settei/kintai/empty'
  },
  KoutsuhiPatternList: {
    get: '/settei/koutsuhi'
  },
  KoutsuhiPatternEdit: {
    get: '/settei/koutsuhi/{id}',
    post: '/settei/koutsuhi',
    put: '/settei/koutsuhi',
    delete: '/settei/koutsuhi/{id}',
    empty: '/settei/koutsuhi/empty'
  },
  KoutsuhiKeiro: {
    empty: '/koutsuhi/keiro/empty'
  },
  KoutsuhiBrowse: {
    get: '/koutsuhi/browse/{year}/{month}/{day}'
  },
  KoutsuhiInput: {
    get: '/koutsuhi/{year}/{month}/{day}',
    post: '/koutsuhi/{year}/{month}/{day}',
    put: '/koutsuhi/{year}/{month}/{day}',
    delete: '/koutsuhi/{year}/{month}/{day}',
    empty: '/koutsuhi/empty'
  },
  KoutsuhiList: {
    get: '/koutsuhi/{year}/{month}'
  },
  ShouninInput: {
    get: '/shounin/{year}/{month}/{userId}',
    post: '/shounin/{shouninId}',
    empty: '/shounin/empty'
  },
  KanryoKaijo: {
    post: '/shounin/kaijo/{year}/{month}/{userId}'
  },
  ShouninList: {
    get: '/shounin/tasks'
  },
  ShouninRireki: {
    get: '/shounin/history/{year}/{month}/{userId}'
  },
  ShouninRoute: {
    get: '/shounin/route',
    put: '/shounin/route'
  },
  Export: {
    all: '/export/all',
    getsudo: '/export/{year}/{month}',
    list: '/export/list/{year}/{month}',
    other: '/export/{userId}/{year}/{month}'
  },
  ExportChienShoumei: {
    day: '/export/chienshoumei/{userId}/{year}/{month}/{day}',
    getsudo: '/export/chienshoumei/{year}/{month}',
    otherDay: '/export/chienshoumei/{userId}/{year}/{month}/{day}',
    otherGetsudo: '/export/chienshoumei/{userId}/{year}/{month}'
  },
  User: {
    get: '/user/all'
  },
  UserPasswordChange: {
    put: '/user/password'
  },
  Toiawase: {
    post: '/toiawase',
    upload: '/toiawase/upload'
  },
  MUser: {
    list: '/master/user/list',
    get: '/master/user/{userId}',
    empty: '/master/user/empty',
    post: '/master/user',
    put: '/master/user/{userId}',
    delete: '/master/user/{userId}'
  },
  MShozoku: {
    list: '/master/shozoku/list',
    get: '/master/shozoku/{id}',
    empty: '/master/shozoku/empty',
    post: '/master/shozoku',
    put: '/master/shozoku/{id}',
    delete: '/master/shozoku/{id}'
  },
  MShokui: {
    list: '/master/shokui/list',
    get: '/master/shokui/{id}',
    empty: '/master/shokui/empty',
    post: '/master/shokui',
    put: '/master/shokui/{id}',
    delete: '/master/shokui/{id}'
  }
}
export const buildPath = (path: string, params: KeyInfo = {}): string => {
  let resultPath = path
  Object.keys(params).forEach((key: string) => {
    resultPath = resultPath.replace(`{${key}}`, String(params[key]))
  })
  return resultPath
}

export const buildQueryString = (path: string, params: ApiGeneralSinglePayload): string => {
  const paramList = Object.keys(params).map((p: string) => `${p}=${params[p]}`)
  return `${path}?${paramList.join('&')}`
}
